


















































import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { PipelineConnection } from '@/api/model/pipeline-connection'
import { InputSelectOption } from '@/helpers/options'
import { Pipeline } from '@/api/model/pipeline'
import { PipelineAPI } from '@/api/backend-client'
import InputSwitch from '@/components/input/InputSwitch.vue'
import InputSelect from '@/components/input/InputSelect.vue'
import InputMultiSelect, { SelectOption } from '@/components/input/InputMultiSelect.vue'
import LoaderBalls from '@/components/LoaderBalls.vue'
import TooltipDecorator from '@/components/input/label/decorator/TooltipDecorator.vue'

@Component({
    components: {
        InputSwitch,
        InputSelect,
        InputMultiSelect,
        LoaderBalls,
        TooltipDecorator,
    },
})
export default class EditOutgoingPipelineConnection extends Vue {
    @Prop({ required: true }) readonly pipelineConnection!: PipelineConnection
    pipelines: Pipeline[] = []
    internalValue: PipelineConnection = null
    loading: boolean = false

    created(): void {
        this.internalValue = this.pipelineConnection
    }

    async mounted(): Promise<void> {
        this.loading = true
        this.pipelines = await PipelineAPI.getAll({
            company: this.pipelineConnection.targetCompany.id,
        })
        this.loading = false
    }

    @Watch('pipelineConnection')
    onPipelineConnectionChanged() {
        this.internalValue = this.pipelineConnection
    }

    @Watch('internalValue')
    onInternalValueChanged() {
        this.$emit('input', this.internalValue)
    }

    get currentPipelineId() {
        return this.internalValue.pipeline?.id
    }

    set currentPipelineId(value) {
        this.internalValue.pipeline = this.pipelines.find(p => p.id === value)
    }

    get availablePipelines(): InputSelectOption[] {
        return this.pipelines.map(entry => ({
            label: entry.name,
            value: entry.id,
        }))
    }

    get excludedFieldOptions(): SelectOption[] {
        return [
            { label: 'Order waarde', value: 'orderValue' },
            { label: 'Netto order waarde', value: 'nettoOrderValue' },
            { label: 'Commissie', value: 'leadCommission' },
        ]
    }
}
